<template>
  <div>
    <router-link v-if="shouldGoBackToAppointmentNeeded" :class="linkClasses" :to="routes.appointmentNeeded">Go Back</router-link>
    <router-link v-else-if="shouldGoBackToAppointmentNotNeeded" :class="linkClasses" :to="routes.appointmentNotNeeded">Go Back</router-link>
    <router-link v-else-if="currentStep > 1 && currentStep < totalSteps" :class="linkClasses" :to="routes[`step${currentStep}`]">Continue Assessment</router-link>
    <router-link v-else-if="shouldShowFallback" :class="linkClasses" :to="fallbackBackRoute">Go Back</router-link>
  </div>
</template>

<script>
import {mapState} from "vuex"

export default {
  name: "ContinueLink",

  props: {
    fallbackBackRoute: Object,

    type: {
      type: String,
      default: () => 'btn',
    }
  },

  computed: {
    ...mapState("survey", [
      "currentStep",
      "surveyComplete",
      "totalSteps",
      "needsAppointment",
    ]),

    linkClasses() {
      return this.type === 'btn' ? 'btn btn-next' : this.type;
    },

    shouldGoBackToAppointmentNeeded() {
      return (this.currentStep === null || this.currentStep === this.totalSteps) && this.needsAppointment === true;
    },

    shouldGoBackToAppointmentNotNeeded() {
      return (this.currentStep === null || this.currentStep === this.totalSteps) && this.needsAppointment === false;
    },

    shouldShowFallback() {
      if (!this.fallbackBackRoute) {
        return false;
      }

      return !(
        this.shouldGoBackToAppointmentNeeded ||
        this.shouldGoBackToAppointmentNotNeeded
      );
    },
  },
}
</script>
